export const cassetteFallbackMetadata = {
    location: { city: 'Тюмень', address: 'Локальный пример' },
    today: '2026-05-20',
    permissions: { can_mutate: true },
    summary: {
        batch_count: 1,
        cassette_count: 12,
        guarantee_count: 1,
        replacement_count: 0,
    },
    batches: [
        {
            territory: {
                id: 1,
                name: 'КИЦ Волгоградский (Москва)',
                address: 'Москва',
            },
            arrival_date: '2026-05-07',
            number_kits: 231,
            total_count: 12,
            good_count: 8,
            bad_count: 4,
            days_left: 2,
            has_pending_repair: true,
        },
    ],
};

export const cassetteFallbackDetailMap = {
    '1:2026-05-07:231': {
        batch: cassetteFallbackMetadata.batches[0],
        permissions: { can_mutate: true },
        filters: { search: '' },
        results: {
            items: [
                {
                    id: 101,
                    serial_number: 'CEGD200456',
                    party_number: 'S7430005582',
                    system: 'CIT 2X',
                    repair_status: 'Ожидает ремонт',
                    movement_status: 'В РЦ',
                    arrival_date: '2026-05-07',
                    date_repair: null,
                    engineer: 'Петров П.П.',
                    comment: '',
                    number_kits: 231,
                    territory: cassetteFallbackMetadata.batches[0].territory,
                    location: { city: 'Тюмень' },
                },
                {
                    id: 102,
                    serial_number: 'CGJX200457',
                    party_number: 'S7430006721',
                    system: 'CIT 5X',
                    repair_status: 'Готов',
                    movement_status: 'В РЦ',
                    arrival_date: '2026-05-07',
                    date_repair: '2026-05-10',
                    engineer: 'Иванов И.И.',
                    comment: 'Проверено',
                    number_kits: 231,
                    territory: cassetteFallbackMetadata.batches[0].territory,
                    location: { city: 'Тюмень' },
                },
            ],
            pagination: {
                page: 1,
                page_size: 25,
                total_pages: 1,
                total_items: 2,
                has_next: false,
                has_previous: false,
            },
        },
    },
};

export const cassetteFallbackGuarantee = {
    permissions: { can_mutate: true },
    summary: { total: 1 },
    results: {
        items: [
            {
                id: 201,
                serial_number: 'CGJX300111',
                party_number: 'S7430006721',
                system: 'CIT 5X',
                repair_status: 'МСК',
                movement_status: 'В РЦ',
                arrival_date: '2026-05-02',
                date_repair: '2026-05-12',
                engineer: 'Егоров Е.Е.',
                comment: 'Замена по гарантии',
                number_kits: 280,
                territory: null,
                location: { city: 'Тюмень' },
            },
        ],
        pagination: {
            page: 1,
            page_size: 25,
            total_pages: 1,
            total_items: 1,
            has_next: false,
            has_previous: false,
        },
    },
};
